interface Thresholds {
  low: number;
  medium: number;
  high: number;
}

export const getThresholds = (settings: {
  threshold?: {
    t1?: number;
    t2?: number;
  };
}) => {
  const t1 = settings?.threshold?.t1 ?? 50;
  const t2 = settings?.threshold?.t2 ?? 80;
  return {
    absolute: {
      low: t1,
      medium: t2,
      high: 100,
    },
    scaled: {
      low: t1 / 100,
      medium: t2 / 100,
      high: 1,
    },
  };
};

export const getTextColor = (value: number, thresholds: Thresholds) => {
  if (value < thresholds.low) return '#ff4d4f';
  if (value >= thresholds.low && value < thresholds.medium) return '#faad14';
  return '#52c41a';
};

export const formatGaugeChartData = (value: string, thresholds: Thresholds) => ({
  series: [
    {
      type: 'gauge',
      startAngle: 180,
      endAngle: 0,
      min: 0,
      max: 1,
      splitNumber: 8,
      center: ['60%', '70%'],
      radius: '100%',
      axisLine: {
        lineStyle: {
          width: 6,
          color: [
            [thresholds.low, '#ff4d4f'],
            [thresholds.medium, '#faad14'],
            [thresholds.high, '#52c41a'],
          ],
        },
      },
      pointer: {
        icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
        length: '50%',
        width: 5,
        offsetCenter: [0, '-10%'],
        itemStyle: {
          color: 'auto',
        },
      },
      axisTick: { show: false },
      splitLine: { show: false },
      axisLabel: { show: false },
      title: { show: false },
      detail: { show: false },
      tooltip: {
        show: true,
        formatter: '{b}',
      },
      data: [
        {
          value: parseFloat(value) / 100,
          name: `Flow Completion Rate ${value}%`,
        },
      ],
    },
  ],
});
